import { useEffect, useState } from 'react';
import octopusInstance from '../../services/octopus/octopusInstance';
import { getExchangeCode } from '../../services/exchanges';

/**
 * Subscribes per-alert to DetailMarketDataMessage and returns the latest LTP
 * + percent change. One subscription per (exchange, token) — automatically
 * unsubscribed on unmount.
 */
const useAlertLtp = ({ exchange, token, initialLtp }) => {
  const [data, setData] = useState({
    ltp: initialLtp ?? null,
    percentChange: null,
  });

  useEffect(() => {
    if (!exchange || !token) return undefined;
    const handler = octopusInstance.wsHandler({
      messageType: 'DetailMarketDataMessage',
      subscriptionLocation: `price-alert-${token}`,
      payload: {
        exchangeCode: getExchangeCode(exchange),
        instrumentToken: token,
      },
    });

    handler.subscribe(({ msg }) => {
      setData((prev) => ({
        ltp: msg.lastTradedPrice ?? prev.ltp,
        percentChange: msg.percentChange ?? prev.percentChange,
      }));
    });

    return () => handler.unsubscribe();
  }, [exchange, token]);

  return data;
};

export default useAlertLtp;
